// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".primary_button-module__primary--2Pmf6{cursor:pointer;outline-style:none;border-radius:2px;text-decoration:none;word-break:keep-all;white-space:nowrap;overflow:hidden;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;height:40px;min-width:80px;padding:0 16px;font-weight:500;font-size:16px;line-height:24px;letter-spacing:0px;background-color:#36b;color:#fff}.primary_button-module__primary--2Pmf6:hover:not([disabled]){background:#285094;color:#f9fafb}.primary_button-module__primary--2Pmf6:disabled{border:1px solid #c6ced5;color:#c6ced5;background:transparent;cursor:not-allowed}\n", ""]);
// Exports
exports.locals = {
	"primary": "primary_button-module__primary--2Pmf6"
};
module.exports = exports;
